// extracted by mini-css-extract-plugin
export default {"wrapper":"I2-z","play":"J2-z"};